import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SiteTreeToolbarComponent } from './site-tree-toolbar/site-tree-toolbar';
import { SiteTreeFileDatabaseService } from './service/site-tree-file-database.service';
import { SiteTreeDisplayComponent } from './display/tree-leaf-display';
import { AdminBaseModule } from '../../../../../../../common/admin-base/admin-base.module';

@NgModule({
  imports: [CommonModule, AdminBaseModule],
  declarations: [SiteTreeToolbarComponent, SiteTreeDisplayComponent],
  providers: [SiteTreeFileDatabaseService],
  exports: [SiteTreeToolbarComponent],
})
export class SiteTreeModule {}
